import React from 'react';
import { ToastContainer } from 'react-toastify';

import MarketingInsights from '../components/MarketingInsights';
import { MarketingInsightsProvider } from '../context/MarketingInsightsContext';

const MarketingInsightsApp = (props) => (
  <MarketingInsightsProvider value={props}>
    <MarketingInsights />
    <ToastContainer icon={false} />
  </MarketingInsightsProvider>
);

export default MarketingInsightsApp;
